import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.w3c.dom.Audio
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLInputElement
import kotlin.coroutines.Continuation
import kotlin.coroutines.EmptyCoroutineContext
import kotlin.coroutines.startCoroutine
import kotlin.random.Random
import kotlin.time.Duration.Companion.milliseconds
import kotlin.time.Duration.Companion.seconds

fun main() {
    val boops = arrayOf(Audio("/boop.wav"), Audio("/boop.wav"), Audio("/boop.wav"))
    val ehh = Audio("/ehh.wav")
    window.onload = {
        val timerTime = document.getElementById("maxTime") as HTMLInputElement
        val flashCircle = document.getElementById("flashCircle")!!
        val goButton = document.getElementById("go") as HTMLButtonElement
        goButton.addEventListener("click", {
            val maxTime = timerTime.valueAsNumber
            if (maxTime.isNaN()) {
                window.alert("Please enter a valid number.")
                return@addEventListener
            }
            if (!maxTime.isFinite()) {
                window.alert("Infinity is a long time.")
                return@addEventListener
            }
            if (maxTime < 10) {
                window.alert("Timer must be at least 10 seconds.")
                return@addEventListener
            }
            println("Starting timer for up to $maxTime seconds")

            val halfTime = maxTime / 2
            val panicTime = maxTime / 4 * 3
            val endTime = Random.nextDouble(maxTime - 10, maxTime)
            println("Half-time at $halfTime, panic time at $panicTime, and end time at $endTime.")

            launch {
                goButton.disabled = true
                flashCircle.setAttribute("visibility", "hidden")
                var time = 0.0
                val phaseGetter = Phase.createPhaseGetter(halfTime, panicTime, endTime)
                var phase = phaseGetter(time)
                var boopIndex = 0
                while (phase != Phase.END) {
                    println("Beep! $time")
                    boops[boopIndex++].play()
                    boopIndex %= boops.size
                    flashCircle.setAttribute("visibility", "visible")
                    delay(100)
                    flashCircle.setAttribute("visibility", "hidden")
                    delay(phase.timeBetweenBeeps.seconds - 100.milliseconds)
                    time += phase.timeBetweenBeeps
                    phase = phaseGetter(time)
                }
                flashCircle.setAttribute("visibility", "visible")
                ehh.play()
                goButton.disabled = false
            }
        })
    }
}

// https://gist.github.com/nosix/5994e53d5bef20292b998d6690649dc1
fun launch(block: suspend () -> Unit) {
    block.startCoroutine(object : Continuation<Unit> {
        override val context get() = EmptyCoroutineContext
        override fun resumeWith(result: Result<Unit>) = Unit
    })
}

enum class Phase(val timeBetweenBeeps: Double) {
    FIRST_HALF(1.0),
    SECOND_HALF(0.5),
    PANIC(1 / 3.0),
    END(0.0);

    companion object {
        fun createPhaseGetter(vararg times: Double): (Double) -> Phase {
            if (times.size != Phase.values().size - 1) {
                throw IllegalArgumentException("times count must be equal to Phase count - 1.")
            }
            return inner@ { time ->
                for ((i, testTime) in times.withIndex()) {
                    if (time <= testTime) {
                        return@inner Phase.values()[i]
                    }
                }
                END
            }
        }
    }
}
